import { Modal, Button, Row, Col } from "react-bootstrap";
import { modal } from "@/utils/constant";
import { useState } from "react";

function PauseModal({ hide, show, handlePause }) {
  const [isClick, setIsClick] = useState(false);

  return (
    <Modal show={show} onHide={hide} size="lg" centered>
      <Modal.Header className="bg-secondary" closeButton>
        <Modal.Title>{modal?.paushModalTitalText}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-10 px-lg-14">
        <p className="mb-3">{modal?.puashModalBodyText}</p>
        <Row className="mt-8">
          <Col>
            <Button
              variant="secondary"
              className="font-semibold w-full"
              disabled={isClick}
              onClick={() => {
                setIsClick(true);
                handlePause();
              }}
            >
              {modal?.puashModalButtonText}
            </Button>
          </Col>
          <Col>
            <Button
              variant="outline-primary"
              className="font-semibold w-full"
              onClick={hide}
            >
              {modal?.cancle}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
export default PauseModal;
